/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { ResetAnswer } from '../ResetAnswer';
import QuestionRenderer from '../QuestionRenderer';
import useStyles from './subQuestionStyles';

export const SubQuestion = ({
  question,
  handleCancelClick,
  sidebarState,
  value,
  onChange,
  isCancelButtonShown,
  resetAnswer,
  isResetAnswerShown,
  shouldNextButtonBeShown,
  handleNextButtonClick,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.question}>
        <QuestionRenderer
          question={question}
          sidebarState={sidebarState}
          value={value}
          onChange={onChange}
          shouldNextButtonBeShown={shouldNextButtonBeShown}
          handleNextButtonClick={handleNextButtonClick}
        />
        {isResetAnswerShown && <ResetAnswer handleReset={resetAnswer} />}
      </div>
      {isCancelButtonShown && (
        <Button
          color="primary"
          variant="text"
          className={classes.cancel}
          onClick={handleCancelClick}
        >
          Cancel
        </Button>
      )}
    </div>
  );
};

SubQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  handleCancelClick: PropTypes.func.isRequired,
  isCancelButtonShown: PropTypes.bool.isRequired,
  isResetAnswerShown: PropTypes.bool.isRequired,
  sidebarState: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  resetAnswer: PropTypes.func.isRequired,
  value: PropTypes.any,
  shouldNextButtonBeShown: PropTypes.bool.isRequired,
  handleNextButtonClick: PropTypes.func.isRequired,
};
